/* ==========================================================================
   EcomHub Pro — Theme Security
   Deterrents against casual copying. Read the honest limits below before
   assuming this protects anything.

   WHAT THIS DOES:  stops right-click, common devtools shortcuts, image
                    dragging and text selection on the STOREFRONT.
   WHAT IT CANNOT DO: DevTools still opens from the browser's own menu,
                    `view-source:` still works, and the page source is served
                    publicly by Shopify either way. This raises the effort of
                    casual copying; it is not a security boundary.

   It never runs in the theme editor (see the snippet's design_mode guard), so
   the merchant can always work on their own store.
   ========================================================================== */
(function () {
  'use strict';

  var cfgEl = document.getElementById('ehp-security-config');
  if (!cfgEl) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent || '{}');
  } catch (e) {
    /* a malformed config must never break the storefront */
    return;
  }
  if (!cfg || cfg.enabled !== true) return;

  /* Never interfere with a form the customer is legitimately typing into —
     blocking right-click or selection inside checkout fields, search boxes or
     an address form would break real shopping, not deter copying. */
  function isEditable(el) {
    if (!el || !el.closest) return false;
    return !!el.closest('input, textarea, select, [contenteditable="true"], [contenteditable=""]');
  }

  if (cfg.rightClick) {
    document.addEventListener(
      'contextmenu',
      function (e) {
        if (isEditable(e.target)) return;
        e.preventDefault();
      },
      { capture: true }
    );
  }

  if (cfg.devtools) {
    document.addEventListener(
      'keydown',
      function (e) {
        var k = (e.key || '').toLowerCase();
        var ctrlish = e.ctrlKey || e.metaKey;

        /* F12 */
        if (e.key === 'F12') {
          e.preventDefault();
          return;
        }
        /* Ctrl/Cmd+Shift+I / J / C — inspector, console, element picker */
        if (ctrlish && e.shiftKey && (k === 'i' || k === 'j' || k === 'c')) {
          e.preventDefault();
          return;
        }
        /* Ctrl/Cmd+U — view source */
        if (ctrlish && k === 'u') {
          e.preventDefault();
        }
      },
      { capture: true }
    );
  }

  if (cfg.imageDrag) {
    document.addEventListener(
      'dragstart',
      function (e) {
        var t = e.target;
        if (t && t.tagName === 'IMG') e.preventDefault();
      },
      { capture: true }
    );
  }

  if (cfg.textSelect) {
    /* class on <html> so the CSS can do the work — a JS selectstart handler
       fights the browser on every drag and costs far more than one rule */
    document.documentElement.classList.add('ehp-noselect');
  }
})();
